export const COMMERCE_W3_READINESS_SECTIONS = Object.freeze([
  Object.freeze({
    id: 'catalog',
    title: 'Catalog and immutable prices',
    description: 'Published products, versions, prices, benefits, sale windows, and tax classifications must come from TMS Commerce—not Website constants.',
    owner: 'TMS Commerce · Phase 6A',
    gateIds: Object.freeze(['W0-CAT-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'adjustments',
    title: 'Coupons, discounts, referrals, and tax',
    description: 'Commerce must calculate eligibility, stacking, price snapshots, referral attribution, and tax. Wyoming registration is not a universal zero-tax rule.',
    owner: 'Contract registration required',
    gateIds: Object.freeze(['W0-CAT-01', 'W0-PAY-01', 'W0-FIN-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'orders',
    title: 'Orders and price snapshots',
    description: 'The browser will submit references only. Commerce must create the idempotent order and own amount, currency, state, buyer, and benefit truth.',
    owner: 'TMS Commerce · Phase 6A',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CAT-01', 'W0-PAY-01', 'W0-FIN-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'stripe',
    title: 'Stripe Checkout and webhooks',
    description: 'Checkout Sessions require an authoritative order. Browser redirect success never settles an order; signed, replay-safe server webhooks must record provider events in Commerce.',
    owner: 'Website edge + TMS Commerce · Phase 6B',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CAT-01', 'W0-PAY-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'paypal',
    title: 'PayPal compatibility',
    description: 'Historical PayPal obligations need accepted TMS custody and reconciliation. No legacy runtime or dual writer is permitted.',
    owner: 'TMS custody pending',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CAT-01', 'W0-PAY-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'swift',
    title: 'SWIFT instructions and review',
    description: 'Transfer instructions and expiring references require Commerce. Customer proof stays pending until privileged maker/checker settlement review succeeds.',
    owner: 'Website edge + TMS Commerce · Phase 6B',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CAT-01', 'W0-PAY-01', 'W0-FIN-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'billing',
    title: 'Invoices, receipts, refunds, and disputes',
    description: 'Customer-bound billing documents and payment reversals need accepted finance schemas, retention, authorization, and reconciliation controls.',
    owner: 'TMS Commerce · Phase 6B',
    gateIds: Object.freeze(['W0-ID-01', 'W0-PAY-01', 'W0-FIN-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'webinars',
    title: 'Webinar and course commerce',
    description: 'Commerce can eventually settle a purchase, but Content must own the catalog, schedule, registration, enrollment, and fulfillment readback.',
    owner: 'TMS Commerce Phase 6 + Content Phase 8',
    gateIds: Object.freeze(['W0-ID-01', 'W0-PAY-01', 'W0-CONT-01', 'W0-CAL-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'consultations',
    title: 'Consultation payment and booking',
    description: 'Calendar ownership must be chosen first. Google Calendar may be an adapter, but neither a browser payment claim nor a slot URL authorizes a booking.',
    owner: 'Owner decision required',
    gateIds: Object.freeze(['W0-ID-01', 'W0-PAY-01', 'W0-CAL-01', 'W0-COMMS-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'cutover',
    title: 'Reconciliation and route cutover',
    description: 'Each method/path, provider-object cohort, and currency must reconcile with one writer, one event ingress, a mutually exclusive rollback, and Ivan’s approval.',
    owner: 'Website W5 · TMS Phases 13–14',
    gateIds: Object.freeze(['W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
]);
